import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import { Thead, Tr, Th,} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//Import actions redux
import { deleteParameters } from "../../store/actions";
import { connect } from "react-redux";
//i18n
import { withNamespaces } from "react-i18next";


class ParametersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      params: this.props.params,
      deletePARAM: false,
      paramToDel: null,
    };
  }

  delPARAM() {
    this.props.deleteParameters(
      this.state.user,
      this.state.paramToDel,
      this.props.history
    );
    this.setState({ deletePARAM: false });
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">Parámetros de seguridad</CardTitle>
                <div className="table-responsive">
                  <table className="table table-nowrap table-centered mb-0">
                    <Thead>
                      <Tr>
                        <Th>
                          <i className="bx bx-at mr-1"></i>
                          Ip
                        </Th>
                        <Th>
                          <i className="bx bx-hash mr-1"></i>
                          {this.props.t("Puerto")}
                        </Th>
                        <Th>
                            <i className="bx bx-pencil mr-1"></i>
                            {this.props.t("Acciones")}
                        </Th>
                      </Tr>
                    </Thead>
                    <tbody>
                      {
                      this.props.params?.map((param, key) => {
                        return (
                          <tr key={key}>
                            <td>
                              <span className="txtName">{param.ip??"-"}</span>
                            </td>
                            <td>
                              <span className="txtName">{param.port??"-"}</span>
                            </td>
                            <td>
                              <Button
                                color={"danger"}
                                className="btn btn-primary waves-effect waves-light buttonStatus wsButton"
                                onClick={() =>
                                  this.setState({
                                    deletePARAM: true,
                                    paramToDel: param.ip,
                                  })
                                }
                              >
                                Eliminar
                              </Button>
                              {
                                this.state.deletePARAM 
                                  ? (
                                      <SweetAlert
                                        showCancel
                                        title="¿Estás seguro?"
                                        cancelBtnBsStyle="danger"
                                        confirmBtnBsStyle="success"
                                        confirmBtnText={this.props.t("ok")}
                                        cancelBtnText={this.props.t("Cancel")}
                                        onConfirm={() => this.delPARAM()}
                                        onCancel={() =>
                                          this.setState({ deletePARAM: false })
                                        }
                                      ></SweetAlert>
                                    ) 
                                  : null
                              }
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const {errorDeletePARAM, loadingDeletePARAM, param, successDeletePARAM} = state.deletePARAM;
  return { errorDeletePARAM, loadingDeletePARAM, param, successDeletePARAM };
};
export default withRouter(
  connect(mapStateprops, { deleteParameters })(
    withNamespaces()(ParametersList)
  )
);
